import React from 'react'

import data from '../../../../data/utilities'
import { UtilitiesIcon } from '../../../../icons'

import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const Utilities = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="utilities"
            icon={() => <UtilitiesIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as UtilityDescription }

export default Utilities
